import React from 'react'
import { css } from '@emotion/core'

type Props = {
  onClose: () => void
  children: React.ReactNode
}
export const ReadRoomKeyAnnounceModal: React.FC<Props> = props => {
  return (
    <>
      <div css={backgroundStyle}></div>
      <div css={dialogStyle}>
        <div css={modalCloseStyle}>
          <img src={require('@/static/images/delete_orange.svg')} width={30} onClick={props.onClose} />
        </div>
        <div className="content-block">
          <img src={require('@/static/images/self-checkin-payment/terminal/icon_ng.svg')} />
          <div className="-text" style={{ paddingTop: 24 }}>
            {props.children}
          </div>
        </div>
      </div>
    </>
  )
}

const backgroundStyle = css({
  background: 'rgba(0, 0, 0, 0.5)',
  height: '100vh',
  width: '100vw',
  position: 'fixed',
  zIndex: 1000,
  top: 0,
  left: 0,
})
const dialogStyle = css({
  position: 'fixed',
  zIndex: 1001,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  background: '#FFFFFF',
  borderRadius: 5,
  '.content-block': {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '40px 70px',
  },
  '.-text': {
    fontSize: 24,
    fontWeight: 'bold',
    letterSpacing: 1.05,
    color: '#272727',
    textAlign: 'center',
    wordBreak: 'keep-all',
    lineHeight: 1.5,
  },
})

const modalCloseStyle = css({
  position: 'absolute',
  top: 0,
  right: 0,
  padding: '24px 24px 0 0',
  '>img': { cursor: 'pointer' },
})
